<template>
  <div class="chance-list">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="imgUrl" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>

        <div class="activity-top-bottom spaceBetween">
          <div class="top-bottom-list" @click="goChance(item)" v-for="(item,index) in tabList" :key="index"><a style="color:#fff;">{{lanType==1?item.title:item.titleEn}}</a></div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="imgUrl" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>
    </div>

    <div class="row" id="gd1">
      <div class="carbon-neck spaceBetween" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-neck-left">
          <div class="neck-left-title"></div>
          <div class="neck-left-font">{{lanType==1?legList.brief:legList.briefEn}}</div>
        </div>
      </div>

      <div class="phone-neck-all hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-carbon-neck">
          <div class="carbon-neck-title"></div>
          <div class="carbon-neck-font">{{lanType==1?legList.brief:legList.briefEn}}</div>
        </div>
      </div>
    </div>

    <div class="row" id="gd2">
      <div class="someAction-chest" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="someAction-chest-left">
          <img src="@/images/some1.png" alt="#" class="chest-left-img"/>
          <div class="chest-left-center">
            <div class="left-center-title">{{lanType==1?initiative.title:initiative.titleEn}}</div>
            <div class="left-center-font" v-html="lanType==1?initiative.content:initiative.contentEn"></div>
            <!-- <div class="left-center-list">
              <div class="center-list-title">1. 需求端倡导</div>
              <div class="center-list-font">1）发挥自身作用，推动行业及上下游设立、提升绿色电力使用目标。</div>
              <div class="center-list-font">2）加强能源管理，强化与绿色电力使用、应对气候变化相关的信息披露。</div>
              <div class="center-list-font">3）通过政策倡导、意识提升等多种方式为绿色电力应用创造良好的社会环境。</div>
            </div>

            <div class="left-center-list">
              <div class="center-list-title">2. 政策与市场</div>
              <div class="center-list-font">1）了解可再生能源电力交易、可再生能源消纳保障机制以及其他环境权益相关政策。</div>
              <div class="center-list-font">2）积极参与绿色电力相关的政策意见征询，鼓励各项政策的实施落地和协调发展。</div>
            </div>

            <div class="left-center-list">
              <div class="center-list-title">3. 技术与项目</div>
              <div class="center-list-font">1）了解绿色电力的技术及成本趋势，积极尝试绿色电力在不同场景下的应用。</div>
              <div class="center-list-font">2）鼓励与绿色电力相关的金融创新和模式创新，以实现商业与环境双重可持续发展。</div>
              <div class="center-list-font">3）推动绿色电力的新增装机及就近消纳，从而创造更多的环境及社会效益。</div>
            </div>

            <div class="left-center-list">
              <div class="center-list-title">4．交流与合作</div>
              <div class="center-list-font">1）与发售电企业、政府、电网等相关方紧密合作，开展多方共赢的交流与合作。</div>
              <div class="center-list-font">2）秉持开放态度，强化信息共享，持续推进全社会绿色电力应用规模的扩大。</div>
            </div> -->
          </div>
        </div>
        <div class="someAction-chest-right">
          <img src="@/images/some2.jpg" alt="#" class="chest-right-img"/>
        </div>
      </div>

      <div class="phone-someAction-chest hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phoneSomeAction-chest-left">
          <div class="phoneChest-left-center">
            <div class="phoneLeft-center-title">{{lanType==1?initiative.title:initiative.titleEn}}</div>
            <div class="left-center-font" style="font-size: 0.32rem;" v-html="lanType==1?initiative.content:initiative.contentEn"></div>
            <!-- <div class="left-center-list">
              <div class="phoneCenter-list-title">1. 需求端倡导</div>
              <div class="center-list-font">1）发挥自身作用，推动行业及上下游设立、提升绿色电力使用目标。</div>
              <div class="center-list-font">2）加强能源管理，强化与绿色电力使用、应对气候变化相关的信息披露。</div>
              <div class="center-list-font">3）通过政策倡导、意识提升等多种方式为绿色电力应用创造良好的社会环境。</div>
            </div>

            <div class="left-center-list">
              <div class="phoneCenter-list-title">2. 政策与市场</div>
              <div class="center-list-font">1）了解可再生能源电力交易、可再生能源消纳保障机制以及其他环境权益相关政策。</div>
              <div class="center-list-font">2）积极参与绿色电力相关的政策意见征询，鼓励各项政策的实施落地和协调发展。</div>
            </div>

            <div class="left-center-list">
              <div class="phoneCenter-list-title">3. 技术与项目</div>
              <div class="center-list-font">1）了解绿色电力的技术及成本趋势，积极尝试绿色电力在不同场景下的应用。</div>
              <div class="center-list-font">2）鼓励与绿色电力相关的金融创新和模式创新，以实现商业与环境双重可持续发展。</div>
              <div class="center-list-font">3）推动绿色电力的新增装机及就近消纳，从而创造更多的环境及社会效益。</div>
            </div>

            <div class="left-center-list">
              <div class="phoneCenter-list-title">4．交流与合作</div>
              <div class="center-list-font">1）与发售电企业、政府、电网等相关方紧密合作，开展多方共赢的交流与合作。</div>
              <div class="center-list-font">2）秉持开放态度，强化信息共享，持续推进全社会绿色电力应用规模的扩大。</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="gd3">
      <div class="someAction-abdomen spaceBetween" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="someAction-abdomen-list">
          <div class="abdomen-list-title">采购评估工具</div>
          <div class="abdomen-list-center">
            <div class="list-center-li" v-for="(item,index) in tool" :key="index" @click="goPage(item)">{{index+1}}. {{lanType==1?item.title:item.titleEn}}</div>
            <!-- <div class="list-center-li">2. 市场绿电采购途径比较</div>
            <div class="list-center-li">3. 交易流程及主要障碍识别</div>
            <div class="list-center-li">4. 管理层支持保障</div>
            <div class="list-center-li">5. 市场相关方沟通</div>
            <div class="list-center-li">6. 绿电供应商筛选</div>
            <div class="list-center-li">7. 绿电采购实施</div>
            <div class="list-center-li">8. 宣传与影响力扩大</div> -->
          </div>
        </div>
        <div class="someAction-abdomen-list">
          <div class="abdomen-list-title" style="padding-left:12%;">应用培训课程</div>
          <div class="abdomen-list-center" style="margin-left:12%;">
            <div class="list-center-li center-li-right" v-for="(item,index) in curriculum" :key="index" @click="goPage(item)">{{index+1}}. {{lanType==1?item.title:item.titleEn}}</div>
            <!-- <div class="list-center-li center-li-right">2. 企业绿电采购模式介绍及流程详述</div>
            <div class="list-center-li center-li-right">3. 企业绿电采购管理办法论和关键步骤</div>
            <div class="list-center-li center-li-right">4. 企业绿电模式直接采购模式详细介绍</div>
            <div class="list-center-li center-li-right">5. 试点项目案例分享</div> -->
          </div>
        </div>
      </div>

      <div class="phone-someAction-abdomen hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-abdomen-list">
          <div class="carbon-neck-title">采购评估工具</div>
          <div class="phone-abdomen-center">
            <div class="phone-center-list" v-for="(item,index) in tool" :key="index" @click="goPage(item)">{{index+1}}. {{lanType==1?item.title:item.titleEn}}</div>
            <!-- <div class="phone-center-list">2. 市场绿电采购途径比较</div>
            <div class="phone-center-list">3. 交易流程及主要障碍识别</div>
            <div class="phone-center-list">4. 管理层支持保障</div>
            <div class="phone-center-list">5. 市场相关方沟通</div>
            <div class="phone-center-list">6. 绿电供应商筛选</div>
            <div class="phone-center-list">7. 绿电采购实施</div>
            <div class="phone-center-list">8. 宣传与影响力扩大</div> -->
          </div>
        </div>

        <div class="phone-abdomen-list">
          <div class="carbon-neck-title">应用培训课程</div>
          <div class="phone-abdomen-center">
            <div class="phone-center-list center-li-right" v-for="(item,index) in curriculum" :key="index" @click="goPage(item)">{{index+1}}. {{lanType==1?item.title:item.titleEn}}</div>
            <!-- <div class="phone-center-list center-li-right">2. 企业绿电采购模式介绍及流程详述</div>
            <div class="phone-center-list center-li-right">3. 企业绿电采购管理办法论和关键步骤</div>
            <div class="phone-center-list center-li-right">4. 企业绿电模式直接采购模式详细介绍</div>
            <div class="phone-center-list center-li-right">5. 试点项目案例分享</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="gd4">
      <div class="carbon-leg" :class="{'hidden-xs hidden-sm':isShowWeb}" v-if="project.id">
        <div class="carbon-leg-center" >
          <div class="leg-center-left">
            <div class="neck-left-title" style="text-align:left;">{{lanType==1?project.title:project.titleEn}}</div>
            <div class="center-left-middle">
              <div class="left-middle-title">{{lanType==1?project.brief:project.briefEn}}</div>
              <!-- <div class="left-middle-font">5月12日，世界自然基金会（瑞士）北京代表处（以下简称WWF）、企业气候行动共同体（简称CBH）正式开启本年度企业绿色电力需求行动试点项目遴选工作，鼓励多方积极参与。</div>
              <div class="left-middle-font">本次启动遴选的企业绿色电力需求行动试点项目着眼于企业绿色电力应用的落地场景，将按年度遴选企业绿色电力采购试点项目，作为参与试点的企业将获得WWF以及外部第三方咨询公司的技术、商务及政策支持。</div>
              <div class="left-middle-font">项目将深入研究企业所处可再生能源采购政策和市场环境，识别并联系主要决策者、供应商及其他利益相关方；共同推进不同类型可再生能源采购模式的落地。试点项目支持并推动参与企业与其他利益相关者的长期合作，包括可再生能源开发企业、新能源技术企业、电网公司等。</div> -->
              <div class="left-middle-bottom start">
                <div class="chest-bottom-btn" @click="goMechanism(project)">{{lanType==1?'了解更多':'Learn More'}}</div>
              </div>
            </div>
          </div>
          <img :src='project.pic' alt="#" class="leg-center-right">
        </div>
      </div>

      <div class="phone-carbon-leg hidden-md hidden-lg" v-if="isShowWeb && project.id">
        <div class="carbon-neck-title">{{lanType==1?project.title:project.titleEn}}</div>
        <div class="phoneCarbon-leg-center">
          <img src="@/images/someActionImg.png" alt="#" class="leg-center-img"/>
          <div class="leg-center-bottom">
            <div class="center-bottom-title">{{lanType==1?project.brief:project.briefEn}}</div>
            <!-- <div class="center-bottom-font">5月12日，世界自然基金会（瑞士）北京代表处（以下简称WWF）、企业气候行动共同体（简称CBH）正式开启本年度企业绿色电力需求行动试点项目遴选工作，鼓励多方积极参与。</div>
            <div class="center-bottom-font">本次启动遴选的企业绿色电力需求行动试点项目着眼于企业绿色电力应用的落地场景，将按年度遴选企业绿色电力采购试点项目，作为参与试点的企业将获得WWF以及外部第三方咨询公司的技术、商务及政策支持。</div>
            <div class="center-bottom-font">项目将深入研究企业所处可再生能源采购政策和市场环境，识别并联系主要决策者、供应商及其他利益相关方；共同推进不同类型可再生能源采购模式的落地。试点项目支持并推动参与企业与其他利益相关者的长期合作，包括可再生能源开发企业、新能源技术企业、电网公司等。</div> -->
            <div class="center-bottom-footer middle">
              <div class="phoneChest-bottom-btn" @click="goMechanism(project)" v-if="project && project.id">{{lanType==1?'了解更多':'Learn More'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="gd5">
      <div class="carbon-leg" :class="{'hidden-xs hidden-sm':isShowWeb}" v-if="campaignList.length">
        <div class="carbon-chest-title">活动</div>

        <div class="index-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
          <div class="foot-list-left start">
            <div class="list-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
            <div class="list-left-radiu border1 columnCenter">
              <div class="left-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
              <div class="left-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
            </div>
            <div class="list-left-right">
              <div class="left-right-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="left-right-bottom start">
                <div class="right-bottom-list start">
                  <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                  <div class="bottom-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                  <div class="bottom-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                </div>
                <div class="right-bottom-list start">
                  <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                  <div class="bottom-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="foot-list-right">{{lanType==1?'查看详情':'View details'}}</div>
        </div>

        <div class="carbon-chest-bottom middle">
          <div class="chest-bottom-btn" @click="goActivity">{{lanType==1?'了解更多':'Learn More'}}</div>
        </div>
      </div>

      <div class="phone-carbon-leg hidden-md hidden-lg" v-if="isShowWeb && campaignList.length">
        <div class="carbon-neck-title">活动</div>

        <div class="phone-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
          <div class="phone-list-left start">
            <div class="phone-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
            <div class="phone-left-radiu border1 columnCenter">
              <div class="phone-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
              <div class="phone-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
            </div>
            <div class="phone-left-right">
              <div class="phone-right-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="phone-right-bottom start">
                <div class="phone-bottom-list start">
                  <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                  <div class="phone-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                  <div class="phone-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                </div>
                <div class="phone-bottom-list start" style="margin-right:0;">
                  <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                  <div class="phone-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="center-bottom-footer middle">
          <div class="phoneChest-bottom-btn" @click="goActivity">{{lanType==1?'了解更多':'Learn More'}}</div>
        </div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>  
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr,format } from '@/utils/util'
import config from '@/utils/config';
export default {
  name: 'chanceList',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      isShowWeb:config.urlList.isShowWeb,
      type:null,
      lanType:1,
      initiative:{},
      legList:{},
      tool:[],
      curriculum:[],
      project:{},
      campaignList:[],
      tabList:[],
      imgUrl: '',
      pageInfo: {}
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    goChance(item){
      const vm=this
      vm.$router.push({ path:'/projectDetail',query:{id:item.id}  })

    },
    queryProject(id){
      const vm=this
      let obj = {
        id:id,
        token:localStorage.getItem("Cbhtoken")
      }
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/project`,obj
      ).then(res => {
        if(res.data.code==1){
          if(id == 2){
            vm.imgUrl = res.data.data.picStr=`${config.urlList.imgUrl}${res.data.data.pic}`;
            vm.pageInfo = res.data.data
          }
          if(id==9){
            res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
            res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn.replace(/(width|height)="\d*"\s*/g, '') : ''
            vm.initiative = res.data.data
          }else if(id==11){
            // res.data.data.pic = config.urlList.imgUrl + res.data.data.pic
            // vm.project = res.data.data
            vm.queryCampaign()
          }
        }else{
          vm.$toast({
            text: '请登录后再试！',
            type: 'danger',
            duration: 1600
          })
          //vm.$router.push({ path:'/'  })
        }
      })
    },
    queryCampaign(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/news_list`,
        {
          type:1,
          is_recommend:0,
          project_id:2,
          page:1,
          per_page:1
        }
      ).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
            da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.briefEn = da.briefEn?da.briefEn:da.brief
            da.pic=`${config.urlList.imgUrl}${da.pic}`;
            da.updated_at=format(new Date(da.updated_at),'YYYY-MM-DD')
          })
          vm.project = res.data && res.data.data && res.data.data.data.length ? res.data.data.data[0] : {}
        }else{
          vm.project={}
        }
      })
    },
    queryProjectList2(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          if(index==10){
            vm.tool = res.data.data
          }else if(index==12){
            vm.curriculum = res.data.data
          }else if(index==2){
            vm.tabList = res.data.data
          }else{
            let obj = {}
            res.data.data.forEach(da=>{
              da.picStr=`${config.urlList.imgUrl}${da.pic}`
              if(da.id==2){
                obj = da
              }
            })
            vm.legList = obj
          }
          
        }
      })
    },
    queryCampaignList(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/campaign_list`,{
        state:1,
        is_recommend:1,
        per_page:9,
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.addressEn = da.addressEn?da.addressEn:da.address
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.addressStr=format(new Date(da.start_date),' YYYY年');
            da.addressStrEn=format(new Date(da.start_date),' YYYY/');
            da.startTimeMoth=format(new Date(da.start_date),' MM月')
            da.startTimeMothEn=format(new Date(da.start_date),' MM/')
            da.startTimeDay=format(new Date(da.start_date),' DD日')
            da.startTimeDayEn=format(new Date(da.start_date),' DD')
          })
          vm.campaignList=res.data.data.data
        }
      })
    },
    goActivityDetail(item){
      const vm=this
      vm.$router.push({ path:'/activityDetail',query:{id:item.id}})
    },
    goActivity(){
      const vm=this
      vm.$router.push({ path:'/activity'  })
    },
    goPage(item){
      const vm=this
      console.log('2222')
      console.log(vm.$toast)
      if(!localStorage.getItem("Cbhtoken")){
        vm.$toast({
          text: '请登录后再试！',
          type: 'danger',
          duration: 1600
        })
        return
      }
      vm.$router.push({ path:'/projectDetail',query:{id:item.id}  })
    },
    goMechanism(item){
      const vm=this
      console.log("item++++++++++")
      console.log(item)
      vm.$router.push({ path:'/mechanism',query:{id:item.id,type:1}})
    },
    // queryProjectList2(index){
    //   const vm=this
    //   let arr=vm.projectList
    //   axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/6`).then(res => {
    //     if(res.data.code==1){
    //       res.data.data.forEach(da=>{
    //         da.picStr=`${config.urlList.imgUrl}${da.pic}`
    //       })
    //       vm.legList = res.data.data
    //     }
    //   })
    // },
  },
  created () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.queryProject(2)
    vm.queryProject(9)
    //vm.queryProject(11)
    vm.queryCampaign()
    vm.queryProjectList2()
    vm.queryProjectList2(2)
    vm.queryProjectList2(10)
    vm.queryProjectList2(12)
    vm.queryCampaignList()
  }
}
</script>

<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 4.0625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family: 'wwf';
}
.activity-top-bottom{
  width: 7.5rem;
  height: auto;
  position: absolute;
  bottom: 0.375rem;
  left: 50%;
  transform: translateX(-50%);
}
.top-bottom-list{
  font-size: 0.17rem;
  color: #fff;
  font-family: 'wwf';
  letter-spacing: 2px;
  position: relative;
  cursor: pointer;
}
.top-bottom-list::before{
  content: "";
  display: block;
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  height: 3px;
  background: #fff;
}

/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  web 简介  web  **/
.carbon-neck{
  padding: 0.375rem 0.5rem;
  height: auto;
  align-items: flex-start;
}
.carbon-neck-left{
  width: 50%;
  height: auto;
  margin: 0 auto;
}
.neck-left-title{
  font-size: 0.1875rem;
  color: #333333;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.1625rem;
}
.neck-left-font{
  font-size: 0.1125rem;
  color: #000;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.125rem;
}
.carbon-neck-right{
  margin-left: 0.45rem;
}
.neck-right-img{
  width: 100%;
}

/**  phone 简介  **/
.phone-neck-all{
  width: 100%;
  height: auto;
}
.phone-carbon-neck{
  padding: 0.32rem 0.5rem;
  height: auto;
}
.carbon-neck-title{
  font-size: 0.52rem;
  color: #000;
  font-weight: 600;
  margin-bottom: 0.32rem;
}
.carbon-neck-img{
  width: 100%;
  height: auto;
  margin-bottom: 0.24rem;
}
.carbon-neck-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.4;
  margin-bottom: 0.24rem;
  text-align: left;
}

/**  web  需求倡议  **/
.someAction-chest{
  position: relative;
}
.someAction-chest::after{
  content: "";
  display: block;
  clear: both;
}
.someAction-chest-left,.someAction-chest-right{
  width: 54%;
  height: auto;
  z-index: 2;
  float: right;
}
.someAction-chest-left{
  z-index: 9;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: auto;
}
.chest-left-img{
  width: auto;
  height: 100%;
}
.chest-right-img{
  width: 100%;
  height: auto;
}
.chest-left-center{
  padding: 0.375rem 1rem 0.375rem 0.5rem;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.left-center-title{
  font-size: 0.24rem;
  font-family: 'wwf';
  color: #fff;
  font-weight: 600;
  text-align: left;
  margin-bottom: 0.25rem;
}
.left-center-font{
  font-size: 0.1125rem;
  color: #fff;
  text-align: left;
  line-height: 1.6;
}
.left-center-list{
  margin-top: 0.1875rem;
  width: auto;
  height: auto;
}
.center-list-title{
  font-size: 0.125rem;
  color: #fff;
  font-weight: 500;
  text-align: left;
}
.center-list-font{
  font-size: 0.1rem;
  color: #fff;
  text-align: left;
  line-height: 1.6;
}

/**  phone 需求倡议  **/
.phone-someAction-chest{
  padding: 0.375rem 0.5rem;
  height: auto;
  background: #74b9a0;
}
.phoneLeft-center-title{
  font-size: 0.6rem;
  color: #fff;
  text-align: center;
  font-weight: 500;
  margin-bottom: 0.45rem;
}
.phoneCenter-list-title{
  font-size: 0.42rem;
  color: #fff;
  font-weight: 500;
  text-align: left;
  margin-top: 0.5rem;
}

/**  web 工具  **/
.someAction-abdomen{
  padding: 0.375rem 0.5rem;
  height: auto;
  align-items: flex-start;
}
.someAction-abdomen-list{
  flex: 2;
  height: auto;
}
.abdomen-list-title{
  font-size: 0.24rem;
  font-family: 'wwf';
  color: #333333;
  font-weight: 600;
  text-align: left;
  margin-bottom: 0.1625rem;
}
.abdomen-list-center{
  margin-top: 0.2375rem;
  height: auto;
}
.list-center-li{
  width: 88%;
  height: 0.3125rem;
  border-radius: 6px;
  background: #74b9a0;
  padding: 0 0.1375rem;
  font-size: 0.15rem;
  color: #fff;
  text-align: left;
  line-height: 0.3125rem;
  margin-bottom: 0.0625rem;
  cursor: pointer;
}

/**  phone 工具  **/
.phone-someAction-abdomen{
  padding: 0.375rem 0.5rem;
  height: auto;
}
.phone-abdomen-list{
  width: 100%;
  height: auto;
}
.phone-abdomen-center{
  width: 100%;
  height: auto;
  margin-bottom: 0.46rem;
}
.phone-center-list{
  padding: 0 0.32rem;
  height: 1.2rem;
  font-size: 0.32rem;
  color: #fff;
  background: #74b9a0;
  border-radius: 6px;
  text-align: left;
  line-height: 1.2rem;
  margin-bottom: 0.2rem;
}

/**  web  案例  **/
.carbon-chest-title{
  font-size: 0.1875rem;
  color: #333333;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.1625rem;
}
.carbon-leg{
  padding: 0.32rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.carbon-leg-center{
  width: 100%;
  height: auto;
  position: relative;
}
.leg-center-left{
  width: auto;
  height: auto;
  position: relative;
  z-index: 9;
}
.center-left-middle{
  width: 54%;
  padding: 0.25rem 0.375rem;
  padding-right: 0.75rem;
  height: auto;
  background: #fff;
  min-height: 3.2rem;
}
.left-middle-title{
  font-size: 0.1125rem;
  color: #333;
  line-height: 1.4;
  font-weight: 500;
  text-align: left;
  width: 50%;
}
.left-middle-font{
  font-size: 0.0875rem;
  color: #333;
  line-height: 1.8;
  text-align: left;
  margin-top: 0.25rem;
}
.left-middle-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.225rem;
}
.leg-center-right{
  width: 50%;
  height: 3.0875rem;
  position: absolute;
  top: 0;
  right: 0;
}
.chest-bottom-btn{
  width: 1.1875rem;
  height: 0.3125rem;
  text-align: center;
  line-height: 0.3125rem;
  background: #74b9a0;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

/**  phone  案例  **/
.phone-carbon-leg{
  padding: 0.48rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.phoneCarbon-leg-center{
  margin-top: 0.48rem;
  width: 100%;
  height: auto;
}
.leg-center-img{
  width: 100%;
  height: auto;
  border-radius: 6px 6px 0 0;
}
.leg-center-bottom{
  padding: 0.42rem 0.24rem;
  height: auto;
  background: #fff;
  border-radius: 0 0 6px 6px;
}
.center-bottom-title{
  font-size: 0.32rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 0.42rem;
}
.center-bottom-font{
  font-size: 0.24rem;
  color: #333;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.28rem;
}

/**  web  活动  **/
.index-foot-list{
  width: 100%;
  height: 0.75rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.225rem;
  cursor: pointer;
}
.foot-list-left{
  width: auto;
  height: 0.75rem;
}
.list-left-tips{
  width: 0.1875rem;
  height: 0.75rem;
  background: #74b9a0;
  font-size: 0.15rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
  letter-spacing: 4px;
}
.list-left-radiu{
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-left: 0.125rem;
  border: 2px solid #74b9a0;
}
.left-radiu-tips{
  font-size: 0.15rem;
  color: #74b9a0;
  font-weight: 'wwf';
  line-height: 1.4;
}
.left-radiu-center{
  font-size: 0.225rem;
  color: #74b9a0;
  font-family: 'wwf';
  line-height: 1.4;
}
.list-left-right{
  margin-left: 0.2625rem;
  height: 0.75rem;
}
.left-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1;
  margin-top: 0.1625rem;
}
.left-right-bottom{
  margin-top: 0.1125rem;
}
.bottom-list-img{
  width: 0.1875rem;
  height: auto;
  margin-right: 0.0625rem;
}
.right-bottom-list{
  margin-right: 0.25rem;
}
.bottom-list-font{
  font-size: 0.1125rem;
  color: #000;
  line-height: 0.1875rem;
}
.foot-list-right{
  color: #74b9a0;
  font-size: 0.1125rem;
  margin-right: 0.175rem;
  cursor: pointer;
  opacity: 0.8;
}

/**  phone  活动  **/
.phone-foot-list{
  width: 100%;
  height: 2.4rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.533rem;
}
.phone-list-left{
  width: auto;
  height: 2.4rem;
}
.phone-left-tips{
  width: 0.56rem;
  height: 2.4rem;
  background: #74b9a0;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
  letter-spacing: 4px;
}
.phone-left-radiu{
  width: 1.333rem;
  min-width: 1.333rem;
  height: 1.333rem;
  border-radius: 50%;
  margin-left: 0.347rem;
  border: 2px solid #74b9a0;
}
.phone-radiu-tips{
  font-size: 0.32rem;
  color: #74b9a0;
  font-weight: 'wwf';
  line-height: 1.4;
}
.phone-radiu-center{
  font-size: 0.48rem;
  color: #74b9a0;
  font-family: 'wwf';
  line-height: 1.4;
}
.phone-left-right{
  margin-left: 0.373rem;
  height: 2.4rem;
}
.phone-right-title{
  font-size: 0.4rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-top: 0.2667rem;
  text-align: left;
}
.phone-right-bottom{
  margin-top: 0.32rem;
}
.phone-list-img{
  width: 0.426rem;
  height: auto;
  margin-right: 0.133rem;
}
.phone-bottom-list{
  margin-right: 0.8rem;
}
.phone-list-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 0.426rem;
}
.phoneChest-bottom-btn{
  width: 2.5rem;
  height: 0.67rem;
  text-align: center;
  line-height: 0.67rem;
  background: #74b9a0;
  font-size: 0.32rem;
  color: #fff;
  font-weight: 600;
}


.center-li-right{
  color: #74b9a0;
  background: #f5f5f5;
}
</style>
